// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionsPanelItem_root__Tl9Dx"};